import React from "react";
import MainView from "./views/MainView";
import LoginView from "./views/LoginView";
import NotificationBar from "components/NotificationBar/NotificationBar";

import { Switch, Route } from "react-router-dom";

const FourOFour = () => {
  return (
    <p>
      Invalid path! <b>404</b>
    </p>
  );
};

function App() { 
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" component={LoginView} />
        <Route path="/cfd" component={MainView} />
        <Route component={FourOFour} />
      </Switch>
      <NotificationBar></NotificationBar>
    </div>
  );
}

export default App;
